import { useTranslation } from 'react-i18next';

import { SearchRefinementListItem } from '../SearchRefinementListItem/SearchRefinementListItem.js';
import { SearchRefinementListItemProps } from '../SearchRefinementListItem/SearchRefinementListItem.types.js';

export interface SearchRefinementListItemI18nProps extends SearchRefinementListItemProps {
  keyPrefix: string;
}

export const SearchRefinementListItemI18n = ({ keyPrefix, ...otherProps }: SearchRefinementListItemI18nProps) => {
  const { t } = useTranslation(undefined, { keyPrefix });

  return <SearchRefinementListItem {...otherProps}>{t(otherProps.item.label)}</SearchRefinementListItem>;
};
